import { storyblokEditable, renderRichText } from "@storyblok/react"
import { motion } from "framer-motion"
import faithImg from "../../../assets/images/bbhc/Faith.png"
import bernadetteImg from "../../../assets/images/bbhc/Bernadette.png"
import jessicaImg from "../../../assets/images/bbhc/Jessica.png"

const imageMap: Record<string, string> = {
  "Faith A.": faithImg,
  "Bernadette R.": bernadetteImg,
  "Jessica P.": jessicaImg,
}

const item = {
  hidden: { opacity: 0, y: 14, filter: "blur(2px)" },
  show: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: { duration: 0.45, ease: "easeOut" },
  },
}

export default function TestimonialItem({ blok }: any) {
  const plainName = (renderRichText(blok.name || { content: [] }) || "")
    .replace(/<[^>]+>/g, "")
    .trim()

  const img = imageMap[plainName] || jessicaImg

  return (
    <motion.article
      {...storyblokEditable(blok)}
      variants={item}
      whileHover={{ y: -4 }}
      className="h-full"
    >
      <div className="rounded-2xl p-[2px] bg-transparent hover:bg-gradient-to-br hover:from-[#EEF1FF] hover:to-transparent transition-colors">
        <div className="h-full flex flex-col rounded-2xl border border-gray-100 bg-white/80 p-6 shadow-[0_1px_8px_rgba(0,0,0,0.04)] hover:shadow-[0_10px_28px_rgba(27,31,59,0.10)] transition-shadow">
          <div className="flex items-center gap-3 mb-5">
            <img
              src={img}
              alt={`${plainName} headshot`}
              className="h-12 w-12 rounded-full object-cover ring-2 ring-white shadow"
            />
            <div className="min-w-0">
              <div
                className="font-['BeausiteClassic'] text-sm md:text-base font-bold text-gray-900 truncate"
                dangerouslySetInnerHTML={{
                  __html: renderRichText(blok.name || { content: [] }) || "",
                }}
              />
              <div
                className="font-['BeausiteClassic'] text-xs md:text-sm text-gray-600"
                dangerouslySetInnerHTML={{
                  __html: renderRichText(blok.role || { content: [] }) || "",
                }}
              />
            </div>
          </div>
          <div className="relative">
            <span className="absolute -left-1 -top-2 text-3xl leading-none text-[#CCD3FF] select-none">
              “
            </span>
            <div
              className="font-['BeausiteClassic'] text-base md:text-lg italic text-gray-800 leading-relaxed pl-4"
              dangerouslySetInnerHTML={{
                __html: renderRichText(blok.quote || { content: [] }) || "",
              }}
            />
          </div>

          <div className="mt-auto" />
        </div>
      </div>
    </motion.article>
  )
}
